import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useBillingMode } from "@/hooks/useBillingMode";

/**
 * /lr-direct entry redirect.
 *
 * v3: brokers and carriers always land on the board regardless of
 * subscription state — browsing is free, paid gate is at the bid action.
 */
export default function LRDirectPage() {
  const { profile, loading, isAdmin } = useAuth();
  const { isLoading: billingLoading } = useBillingMode();
  const userType = profile?.user_type;
  const isDemoUser = (profile as any)?.is_demo_user === true;

  if (loading || billingLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  // Admin / demo → LR Direct broker dashboard.
  if (isAdmin || isDemoUser) return <Navigate to="/lr-direct/broker" replace />;

  // Brokers and carriers → LR Direct broker dashboard (consistent with switcher + nav).
  if (userType === "broker" || userType === "broker_carrier" || userType === "carrier") {
    return <Navigate to="/lr-direct/broker" replace />;
  }

  // Shippers → guided post start (their primary LR Direct surface).
  if (userType === "shipper") return <Navigate to="/lr-direct/post/start" replace />;

  // Unknown → broker dashboard fallback.
  return <Navigate to="/broker-dashboard" replace />;
}
